import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';

export default function NavTab({ to, children }) {
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(`${to}/`);

  return (
    <Button
      component={RouterLink}
      to={to}
      disableRipple
      sx={{
        minWidth: 0,
        px: { xs: 1.25, sm: 2 },
        py: { xs: 0.5, sm: 0.75 },
        borderRadius: 2,
        fontWeight: 600,
        fontSize: { xs: '0.8125rem', sm: '0.9375rem' },
        textTransform: 'none',
        color: active ? '#f8fafc' : '#94a3b8',
        bgcolor: active ? 'rgba(51, 65, 85, 0.9)' : 'transparent',
        border: '1px solid',
        borderColor: active ? 'rgba(129, 140, 248, 0.5)' : 'transparent',
        boxShadow: active ? 'inset 0 0 0 1px rgba(129, 140, 248, 0.15)' : 'none',
        '&:hover': {
          bgcolor: active ? 'rgba(51, 65, 85, 0.9)' : 'rgba(51, 65, 85, 0.5)',
          color: '#f1f5f9',
        },
      }}
    >
      {children}
    </Button>
  );
}
